<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
  export default {
    data(){
      return {

      }
    },
    created(){
      document.title = '箱包手袋工厂经营管理系统'

      //登录状态持久化
      if (localStorage.token && localStorage.userinfo) {
        let userinfo = JSON.parse(localStorage.userinfo)

        this.$store.commit('status/ISLOGIN', true)
        this.$store.commit('userinfo/USERINFO', userinfo)

        if (localStorage.path){
          //保证页面刷新后 路由还是原页面 不加会跳转首页
          if (localStorage.path) this.$router.replace(localStorage.path)
        } else {
          if (userinfo.sfl == 1) { //总管理员
            this.$router.replace("/stf_mgt");
          } else if (userinfo.sfl == 2) { //管理员
            this.$router.replace("/task_mgt");
          } else if (userinfo.sfl == 3) { //员工
            this.$router.replace("/task_make");
          }
        }
      }
    },
    watch: {
      $route(to, from) {
        if (to.path != from.path) {
          localStorage.path = to.path //保证页面刷新后 路由还是原页面 不加会跳转首页
        }
      }
    }
  }
</script>

<style>
  
</style> 
